export const GET_VIDEOS = "GET_VIDEOS";
export const GET_VIDEOS_SUCCESS = "GET_VIDEOS_SUCCESS";
export const GET_VIDEOS_ERROR = "GET_VIDEOS_ERROR";
export const GET_VIDEOS_CATEGORIES = "GET_VIDEOS_CATEGORIES";
export const GET_VIDEOS_SPEECH_LANGUAGES = "GET_VIDEOS_SPEECH_LANGUAGES";
export const GET_GENDERS = "GET_GENDERS";
